export default "__VITE_ASSET__CgUzw6Jb__"